import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoteIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4879 6.76263C14.3254 6.6001 14.1325 6.47118 13.9202 6.38323C13.7078 6.29527 13.4803 6.25 13.2504 6.25C13.0206 6.25 12.793 6.29527 12.5807 6.38323C12.3684 6.47118 12.1754 6.6001 12.0129 6.76263L7.74992 11.0236C7.49463 11.279 7.29211 11.582 7.15392 11.9156L6.30593 13.9626C6.24912 14.0997 6.23425 14.2505 6.26318 14.396C6.29211 14.5415 6.36354 14.6752 6.46845 14.7801C6.57336 14.885 6.70702 14.9564 6.85253 14.9854C6.99804 15.0143 7.14887 14.9994 7.28592 14.9426L9.33293 14.0946C9.6665 13.9564 9.9696 13.7539 10.2249 13.4986L14.4859 9.23663C14.8138 8.90847 14.9981 8.46354 14.9981 7.99963C14.9981 7.53571 14.8138 7.09078 14.4859 6.76263H14.4879Z",
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M4 14.25H3.75C3.19772 14.25 2.75 13.8023 2.75 13.25V2.75C2.75 2.19772 3.19772 1.75 3.75 1.75H10.25C10.8023 1.75 11.25 2.19772 11.25 2.75V4.75" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 4.75H8" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 7.25H8" })
	]
});
export default SvgNoteIcon;
